import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'kv-promo-tab-choose-campaign',
  template: `
    <form (ngSubmit)="selectCampaign()" [formGroup]="form">
      <div class="ui-g form-group master-data">
        <div class="ui-g-12">
          <p-listbox [disabled]="saveAndListBoxDisabled" [options]="wizardCampaigns" formControlName="campaigns"
                     filter="filter">
          </p-listbox>
        </div>
      </div>
      <div class="text-right">
        <button
          pButton
          type="submit"
          class="k-generic-btn"
          icon="fa fa-save"
          label="{{'promotion.saveAndNext' | translate}}"
          [disabled]="form.controls['campaigns'].value === null || saveAndListBoxDisabled">
        </button>
      </div>
    </form>
  `,
  styleUrls: ['./tab-choose-campaign.component.css']
})
export class TabChooseCampaignComponent implements OnInit, OnChanges {

  @Input() wizardCampaigns;
  @Input() disableChooseCampaign;
  @Input() selectedWizard;

  @Output() nextStep = new EventEmitter();
  
  form: FormGroup;
  saveAndListBoxDisabled = false;

  constructor(private fb: FormBuilder) {
    this.createForm();
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disableChooseCampaign'] && changes['disableChooseCampaign'].currentValue === true) {
      this.saveAndListBoxDisabled = true;
      this.form.controls['campaigns'].setValue(this.selectedWizard);
    }
  }

  selectCampaign() {
    this.nextStep.emit(this.form.controls['campaigns'].value);
  }

  createForm() {
    this.form = this.fb.group({
      'campaigns': null
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/choose-campaign/tab-choose-campaign.component.ts